<template>
  <div class="game-sorting-list">
    <label class="form__label">
      Games Sorting
    </label>
    <div class="btns-row">
      <div class="btns-row__right-btns">
        <button class="ark-btn ark-btn--success"
                v-if="feeds.length > 0 && $checkRoles(['Administrator'])"
                @click="createSorting">Create a brand new sorting
        </button>
      </div>
    </div>
    <div v-show="chosenSortingName">
      <div class="btns-row">
        <div class="btns-row__right-btns">
          <button class="ark-btn ark-btn--danger"
                  v-if="chosenSortingName && $checkRoles(['Administrator'])"
                  @click="deleteSorting">Delete
          </button>

          <button class="ark-btn ark-btn--success"
                  v-if="chosenSortingName && $checkRoles(['Administrator'])"
                  @click="save">Save
          </button>
        </div>
      </div>

      <div class="loader-wrap">
        <Loader v-if="isGamesLoaderVisible"></Loader>
      </div>

      <div v-if="!isGamesLoaderVisible">
        <div class="form__row">
          <span>Sorting Name</span>
          <input class="form__input"
                 type="text"
                 :value="chosenSortingName"
                 placeholder="Sorting Name"
                 readonly
                 v-input-trim>
          <!--               v-on:input="choseSorting($event.target.value)"-->
        </div>
        <div class="form__row">
          <label class="form__label">
            Based on the feed
          </label>
          <Loader v-if="areFeedsLoading"></Loader>
          <div class="form__input-box" v-else>
            <select class="form__select" @change="changeFeed" v-model="selectedFeed">
              <option v-for="(feed, i) in feeds"
                      :key="feed.id"
                      :value="feed.name"
                      :selected="sorting.feedName === feed.name"
              >{{feed.name}}
              </option>
            </select>
          </div>
        </div>

        <div class="form__row">
          <span>Filter: </span>
          <FilterInput title="Filter games"
                       :filterByKey="filterFields"
                       :filterList="games"
                       v-on:filter="onFilterGames"
          ></FilterInput>
        </div>

        <ul class="game-list">
          <li
            class="game-list__item"
            v-for="(game, i) in filteredGames"
            :key="game.slug + i">
            <label class="form__label">
              <input type="number"
                     class="form__input"
                     :class="{'is-error': isDuplicateOrder(gameOrderValue(game.slug), game.slug)}"
                     :value="gameOrderValue(game.slug)"
                     v-on:input="changeGameSorting($event.target.value, game.slug)"
              >
              <b v-if="gameOrderValue(game.slug) > 0">{{game.slug}}</b>
              <span v-else>{{game.slug}}</span>
            </label>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  /* eslint-disable indent-legacy */

  import config from '../../../config'
  import Loader from '../../Loader/Loader.vue'
  import FilterInput from '../../FilterInput/FilterInput.vue'
  import {sortAsc} from '../../../utils/sorting'

  export default {
    name: 'GameSortingList',
    components: {Loader, FilterInput},
    props: ['chosenSortingName'],
    data () {
      return {
        sorting: {},
        originalSorting: {},
        games: [],
        feeds: [],
        areFeedsLoading: false,
        filteredGames: [],
        isGamesLoaderVisible: false,
        filterFields: ['slug'],
        selectedFeed: '',
      }
    },
    watch: {
      chosenSortingName: function (newVal, oldVal) { // watch it
        if (newVal) {
          this.getSortingData(newVal)
        }
      }
    },
    created () {
      this.getAllFeeds()
    },
    methods: {
      gameOrderValue: function (game) {
        const gameWithOrder = this.sorting.gamesSorting.find((item) => item.slug === game)
        return gameWithOrder ? gameWithOrder.order : 0
      },
      isDuplicateOrder: function (order, game) {
        if (order) {
          return this.sorting.gamesSorting.some((sortingGame) => {
            return sortingGame.slug !== game && sortingGame.order === order
          })
        }
      },
      onFilterGames: function (games) {
        this.filteredGames = games
      },
      changeGameSorting: function (order, game) {
        const gameInArrIndex = this.sorting.gamesSorting.findIndex((item) => item.slug === game)
        const orderNum = parseInt(order)
        if (gameInArrIndex !== -1) {
          if (orderNum === 0) {
            // delete items with zero index
            this.sorting.gamesSorting.splice(gameInArrIndex, 1)
          } else {
            this.sorting.gamesSorting[gameInArrIndex].order = orderNum
          }
        } else {
          this.sorting.gamesSorting.push({slug: game, order: orderNum})
        }
      },
      changeFeed: function (feed) {
        this.sorting = {...this.originalSorting}
        this.sorting.feedName = this.selectedFeed
        this.getFeedGames(this.selectedFeed)
      },
      getAllFeeds: function () {
        this.areFeedsLoading = true

        this.$gameApi.get(`/feeds`)
          .then(response => {
            this.feeds = response
          }, error => {
            console.log(error)
          })
          .then(() => {
            this.areFeedsLoading = false
          })
      },
      getFeedGames: function (feed) {
        this.games = []
        this.filteredGames = []

        this.$gameApi.get(`/feeds?name=${this.selectedFeed}`)
          .then(response => {
            // don't turn off the loader if there aren't all games yet
            const feed = response && response.length > 0 ? response[0] : null
            let games = []
            if (feed) {
              this.$gameApi.get(`/feeds/${feed.id}?short=true`)
                .then(resp => {
                  games = resp.feedGames.map(g => g.game)
                  this.sorting.gamesSorting = this.sorting.gamesSorting.filter(item => {
                    return item.order !== 0 && games.find(game => game.slug === item.slug)
                  })
                  this.games = games
                  this.filteredGames = {...games}
                })
            }

          }, error => {
            console.log(error)
          })
      },
      getSortingData: function (sortingName) {
        this.sorting = {}
        this.isGamesLoaderVisible = true

        this.$http
          .get(`${config.apiUrl}/sorting/get?sortingName=${sortingName}`)
          .then(response => {
            this.sorting = response.body

            if (!this.sorting.feedName) {
              this.sorting.feedName = 'default'
            }

            this.selectedFeed = this.sorting.feedName
            this.originalSorting = response.body
          }, error => {
            console.log(error)
          })
          .then(() => this.getFeedGames(this.sorting.feedName))
          .then(() => {
            this.isGamesLoaderVisible = false
          })
      },
      save: function () {
        const valueArr = this.sorting.gamesSorting.map((item) => item.order)
        const isDuplicate = valueArr.some((item, idx) => {
          return valueArr.indexOf(item) !== idx
        })

        if (!isDuplicate) {
          this.isLoaderVisible = true // showing loader

          let formData = new FormData()
          formData.append('jsonData', JSON.stringify(
            this.sorting
          ))

          this.$http
            .post(`${config.apiUrl}/sorting/save`, formData)
            .then(() => {
              this.$swal.fire({
                icon: 'success',
                title: 'Success!',
                text: 'Sorting saved successfully'
              })
            }, error => {
              console.log(error)
            })
            .then(() => {
              this.isLoaderVisible = false
            })
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Please correct duplicate orders'
          })
        }
      },
      deleteSorting: function () {
        function _deleteSorting () {
          this.$http.delete(`${config.apiUrl}/sorting/delete?sortingName=${this.chosenSortingName}`)
            .then(() => {
              this.$swal.fire({
                icon: 'success',
                title: 'Success!',
                text: 'Sorting deleted successfully'
              })
              this.$emit('onSortingCreated', null)
            }, error => {
              this.$swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: error
              })
            })
            .then(() => {
              this.isLoaderVisible = false
            })
        }

        this.isLoaderVisible = true

        this.$swal.fire({
          title: 'Are you sure?',
          text: 'You won\'t be able to revert this!',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, delete it!',
          cancelButtonText: 'No, cancel!',
          reverseButtons: true
        }).then((result) => {
          if (result.value) {
            _deleteSorting.call(this)
          } else if (
            /* Read more about handling dismissals below */
            result.dismiss === this.$swal.DismissReason.cancel
          ) {
            this.$swal.fire(
              'Cancelled',
              'Your sorting is safe :)',
              'error'
            )
          }
        })
      },
      createSorting: function () {
        function createNewSorting (newSortingName) {
          if (newSortingName) {
            this.isLoaderVisible = true // showing loader

            let formData = new FormData()
            formData.append('jsonData', JSON.stringify(
              {
                sortingName: newSortingName,
                feedName: 'default',
                gamesSorting: []
              }
            ))

            this.$http
              .post(`${config.apiUrl}/sorting/save`, formData)
              .then(() => {
                this.$emit('onSortingCreated', newSortingName)
                this.$swal.fire({
                  icon: 'success',
                  title: 'Success!',
                  text: 'Sorting created successfully'
                })
              }, error => {
                console.log(error)
              })
              .then(() => {
                this.isLoaderVisible = false
              })
          }
        }

        this.$swal.fire({
          title: 'Please type the new feed name',
          input: 'text',
          inputAttributes: {
            autocapitalize: 'off'
          },
          showCancelButton: true,
          confirmButtonText: 'Create',
          showLoaderOnConfirm: false
        }).then((result) => {
            let newSortingName = result.value
            createNewSorting.bind(this)(newSortingName)
          }
        )
      }
    }
  }
</script>

<style scoped src="./GamesSortingList.scss" lang="scss"></style>
